import {client} from './services/client'

export const precommandes = {
    namespaced: true,
    state: {
        precommandesEncours: [],
        precommandesEff: [],
        precommandesEncoursloading: true,
        precommandesEffloading: true,
        precommandesManuel: undefined,
        precommandeCount: 0,
    },
    mutations: {
        SET_precommandesEncours(state, precommandesEncours) {
            state.precommandesEncours = precommandesEncours
        },
        SET_precommandesEncoursLOADING(state, precommandesEncours) {
            state.precommandesEncoursloading = precommandesEncours
        },
        SET_precommandesEff(state, precommandesEff) {
            state.precommandesEff = precommandesEff
        },
        SET_precommandesEffLOADING(state, precommandesEff) {
            state.precommandesEffloading = precommandesEff
        },

        SET_precommandeCount(state, precommandesEff) {
            state.precommandeCount = precommandesEff
        },

        SET_precommandeManuel(state, precommandesEff) {
            state.precommandesManuel = precommandesEff
        },


    },
    actions: {
        getPrecommandeCours({commit}, data) {
            commit('SET_precommandesEncoursLOADING', true)
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/precommandes/getPrecommandeCours',
                    data: data
                }).then((response) => {
                    let precommandes = response.data.precommandes;
                    console.log(response);
                    commit('SET_precommandesEncours', precommandes)
                    commit('SET_precommandesEncoursLOADING', false)
                                        resolve(response)

                })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getPrecommandesManuel({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/precommandes/getPrecommandesManuel',
                    data: data
                }).then((response) => {
                    let precommandes = response.data.precommandes;
                    commit('SET_precommandeManuel', precommandes)
                                        resolve(response)

                })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getAdminPrecommandeCours({commit}, data) {
            commit('SET_precommandesEncoursLOADING', true)
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/precommandes/getAdminPrecommandeCours',
                    data: data
                }).then((response) => {
                    let precommandes = response.data.precommandes;
                    console.log('response');
                    console.log(response);
                    commit('SET_precommandesEncours', precommandes)
                    commit('SET_precommandesEncoursLOADING', false)
                                        resolve(response)

                })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
         setPrecommandeManuel({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/precommandes/setPrecommandeManuel',
                    data: data
                }).then((response) => {
                    let precommandes = response.data.precommandes;
                     let precommandesmanuel = response.data.precommandesmanuel;
                    console.log('SET_precommandeManuel', precommandes);
                    commit('SET_precommandesEncours', precommandes);
                    commit('SET_precommandeManuel', precommandesmanuel);
                                        resolve(response)

                }).catch((error) => {
                        reject(error);
                })
            })

        },
        setPrecommandeCours({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/precommandes/setPrecommandeCours',
                    data: data
                }).then((response) => {
                    let precommandes = response.data.precommandes;
                    let precommandeseff = response.data.precommandeseff;
                    let precommandesmanuel = response.data.precommandesmanuel;
                    console.log(response);
                    commit('SET_precommandesEncours', precommandes)
                    commit('SET_precommandesEff', precommandeseff)
                    commit('SET_precommandeManuel', precommandesmanuel);
                    resolve(response)

                })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getPrecommandeEff({commit}, data) {
            commit('SET_precommandesEffLOADING', true)
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/precommandes/getPrecommandeCours',
                    data: data
                }).then((response) => {
                    let precommandes = response.data.precommandesC;
                    console.log(response);
                    commit('SET_precommandesEff', precommandes)
                    commit('SET_precommandesEffLOADING', false)
                                        resolve(response)

                })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getPrecommandeEffAdmin({commit}, data) {
            commit('SET_precommandesEffLOADING', true)
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/precommandes/getAdminPrecommandeCours',
                    data: data
                }).then((response) => {
                    let precommandes = response.data.precommandesC;
                    console.log(response);
                    commit('SET_precommandesEff', precommandes);
                    commit('SET_precommandesEffLOADING', false)
                                        resolve(response)

                })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getPrecommandeCount({commit}, data) {
            commit('SET_precommandesEffLOADING', true)
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/precommandes/getPrecommandeCount',
                    data: data
                }).then((response) => {
                    let precommandes = response.data.precommandesC;
                    console.log(response);
                    commit('SET_precommandeCount', precommandes);
                    commit('SET_precommandesEffLOADING', false)
                                        resolve(response)

                })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },

    },
    getters: {
        getPrecommandeCours: state => {
            return state.precommandesEncours
        },
    }
};
